export const STATUS_ENABLED = 'enabled'
export const FACE_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error'
}

export const ENROLLMENT_SECURITY_TYPES = {
  PASSCODE: 'PASSCODE',
  FACE: 'FACE',
}
export const POP_CONFIRM_MESSAGE = {
  ZEBRA: `By enrolling in Zebra Biometric Authentication, you consent and agree to the collection, processing and storage of your biometric data by Zebra Technologies and your employer. Zebra does not store or retain biometric data separately from the encrypted QR code generated during enrollment and biometric signatures are deleted after printing your QR code. Additional policies, processes and procedures may apply with your employer. By continuing to enroll you acknowledge you have read and agreed to the terms stated above.`,
} 

export const ERROR_MESSAGES = {
  INVALID_LINK: 'Your link is invalid, please contact your Admin',
  EXPIRED_TOKEN: 'Token has expired. Please request a new token.', 
  INVALID_URL: 'Invalid URL',
  DEFAULT: 'Please try again later.',
  NETWORK_ERROR: 'Please check your internet connection and please try again later.',
  LICENSE_EXPIRED: 'Face capture service is unavailable. Please contact your Admin.',
}

export const ERROR_TYPES = {
  INVALID_LINK: 'Invalid Link',
  EXPIRED_TOKEN: 'Expired Token',
  INVALID_URL: 'Invalid URL',
  DEFAULT: 'Unknown Error',
  NETWORK_ERROR: 'Network Error',
  LICENSE_EXPIRED: 'Service Unavailable',
}

export const RESPONSE_TYPES = {
  SUCCESS: 200,
  FAILED: 400,
  UNAUTHORIZED: 401,
  UNPROCESSABLE_CONTENT: 422,
  SERVER_ERROR: 500,
  NETWORK_ERROR: 'Network Error' 
}

export const ENROLLMENT_FORM_FIELDS = {
  SECURITY_TYPES: 'securityTypes',
  PASSCODE: 'passcode',
  FILE: 'file',
  FACE_METADATA: 'faceMetadata',
}

export const ENROLLMENT_STEPS = {
  ERROR: 'error',
  RETRY: 'retry',
  AUTHENTICATION: 'authentication',
  PASSCODE_SETUP: 'passcode_setup',
  FACE_SETUP: 'face_setup',
  ENROLLMENT_COMPLETE: 'enrollment_complete'
}

export const ENROLLMENT_FACE_CAPTURE_MESSAGES = {
  FACE_CAPTURE_NOTE_ONE: 'Facial scans allow you to log in faster and more conveniently without typing passwords.',
  FACE_CAPTURE_NOTE_TWO:  'Your secure facial vector is written directly and exclusively to your personal physical card or barcode.',
  FACE_CAPTURE_NOTE_THREE: 'No biometric data is ever sent to, or stored by, the company. You maintain complete physical possession.'
}

export const VERIFICATION_LOADER_STATUS = {
  VERIFYING: 'verifying',
  STILL_PROCESSING: 'still-processing',
  LONGER_THAN_EXPECTED: 'longer-than-expected',
  SUCCESS: 'success',
}

export const VERIFICATION_LOADER_MESSAGES = {
  VERIFYING: 'Verifying...',
  VERIFYING_TITLE: 'Processing biometric data',
  VERIFYING_SUBTITLE: 'This may take a few moments. Please wait.',
  STILL_PROCESSING_TITLE: 'Still processing biometric data',
  STILL_PROCESSING_SUBTITLE: 'We’re securely processing your images. Please wait.',
  LONGER_THAN_EXPECTED_TITLE: 'Verification is taking longer than expected',
  LONGER_THAN_EXPECTED_SUBTITLE: 'Please close this screen and check your email later for the verification result.',
}
export const ENROLLMENT_COMPLETE_MESSAGE = {
  TITLE: 'User Enrollment Complete',
  DESCRIPTION: 'An email has been sent to your registered email address with log-in instructions.'
}
export const ALPHA_NUMERIC_PASSCODE_VALIDATORS = {
  passcodeMinLength: (v, rule) =>
    v.length < rule ? `Passcode must be at least ${rule} characters long` : null,
  passCodeMinNumbers: (v, rule) => {
    const count = (v.match(/\d/g) || []).length;
    return count < rule ? `Passcode must contain at least ${rule} numeric character(s)` : null;
  },
  passcodeMinUppercase: (v, rule) => {
    const count = (v.match(/[A-Z]/g) || []).length;
    return count < rule ? `Passcode must contain at least ${rule} uppercase character(s)` : null;
  },
  passcodeMinLowercase: (v, rule) => {
    const count = (v.match(/[a-z]/g) || []).length;
    return count < rule ? `Passcode must contain at least ${rule} lowercase character(s)` : null;
  },
  passCodeMinSymbols: (v, rule) => {
    const count = (v.match(/[!@#$%^&*(),.?":{}|<>]/g) || []).length;
    return count < rule ? `Passcode must contain at least ${rule} special character(s)` : null;
   }
 }

 export const NUMERIC_PASSCODE_VALIDATORS = {
  passcodeMinLength: (v, rule) =>
    v.length < rule ? `Passcode must be at least ${rule} characters long` : null,
  passcodeType: (v, rule) => {
    const numericregex = /^\d+$/
    console.log("DEBUG: Validate passcodeType", rule)
    return rule === 'Numeric' && ! numericregex.test(v) ? `Passcode must contain only numeric character(s)` : null;
  },
 }

 export const PASSCODE_TYPE = {
    NUMERIC:'Numeric',
    ALPHA_NUMERIC: 'AlphaNumeric'
 }

 export const FACE_CAPTURE_TIPS = [
    {
      title: 'Live lighting',
      description: 'Ensure your face is well lit from the front, with no strong shadows.',
    },
    {
      title: 'Camera position',
      description: 'Hold the camera at eye level and center your face in the frame.',
    },
    {
      title: 'Obscured view',
      description: 'Your entire face should be visible without hats, heavy glasses, mask, or scarves.',
    },
    {
      title: 'Background problems',
      description: 'A plain, neutral background works best. Avoid motion.',
    },
  ];